import React from "react";
import Header from "../../components/Header/Header";
import s from "./MessagesList.module.scss";
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  LeftCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import moment from "moment";

import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { getStatusTag } from "../../utils/functions";
import { useTranslation } from "react-i18next";

const MessagesList = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const messages = useSelector(
    (state: RootState) => state.application.messagesList
  );

  return (
    <div className={s.messages}>
      {width > 700 ? <Header /> : <MobileHeader />}
      <div className={s.messages_content}>
        <Link to='/home' className={s.back}>
          <ArrowLeftOutlined />
          &nbsp; {t("Назад")}
        </Link>
        <div className={s.h2}>{t("Уведомления")}</div>
        <div style={{ width: "80%", margin: "0 auto" }}>
          <Divider orientation='left' style={{ borderColor: "silver" }}>
            <div className={s.application_number}>
              {t("№ заявки")}{" "}
              {messages[0]?.application_details?.application_number}
              <EditOutlined style={{ marginLeft: "5px" }} />
            </div>
          </Divider>
        </div>

        {messages.map((it) => (
          <div className={s.message_block}>
            <div className={s.messages_list}>
              {width > 800 ? (
                <div className={s.messages_item}>
                  <div className={s.status}>
                    <div className={s.status_title}>{t("Cтатус")}</div>
                    <div>{getStatusTag(it?.application_status, "lg", t)}</div>
                  </div>
                  <div>
                    <div className={s.message_item_header}>
                      <div className={s.name}>{it.sender.full_name}</div>
                      <div className={s.date}>
                        {moment(it.created_at).format("DD.MM.YYYY hh:mm")}
                      </div>
                    </div>
                    <div className={s.message}>{it.content}</div>
                  </div>
                </div>
              ) : (
                <div className={s.m_messages_item}>
                  <div className={s.m_status}>
                    <div>{getStatusTag(it?.application_status, "sm", t)}</div>
                    <div className={s.m_date}>
                      {moment(it.created_at).format("DD.MM.YYYY hh:mm")}
                    </div>
                  </div>
                  <div>
                    <div className={s.m_message_item_header}>
                      <div className={s.m_name}>{it.sender.full_name}</div>
                      <div className={s.m_message}>{it.content}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default MessagesList;
